
  import { inject, onMounted, ref } from 'vue';
  import { Collapse } from 'bootstrap';
  import VueScrollTo from 'vue-scrollto';
  import {
    makeHistoryStateProps,
    getHistoryState,
    setHistoryState,
    IHistoryStateProps
  } from '../composables/historyState';

  export default {
    props: {
      parent: {
        type: String,
        default: null
      },
      toggle: {
        type: Boolean,
        default: false
      },
      scroll: {
        type: Boolean,
        default: false
      },
      ...makeHistoryStateProps()
    },
    setup(props: IHistoryStateProps & any) {
      const rootEl = ref<HTMLElement>();
      const lazyLoad = inject<any>('lazyLoad');
      const scrollOffset = inject('scrollOffset');

      let openedItems: String[] = []; // IDs of opened items

      onMounted(() => {
        let collapseElements = rootEl.value ? Array.from(rootEl.value.querySelectorAll('.collapse')) : [];
        if (collapseElements.length) {
          // init Collapse elements
          collapseElements.map((item: any) => {
            return new Collapse(item, {
              parent: typeof props.parent === 'string' ? `#${props.parent}` : props.parent,
              toggle: props.toggle
            });
          });
          // bind event listeners
          collapseElements.forEach((item: any) => {
            item.addEventListener('shown.bs.collapse', () => {
              lazyLoad.update();
              scrollToOpenedItem(item);
              updateOpenedItems(item);
            });
            item.addEventListener('hidden.bs.collapse', () => {
              updateOpenedItems(item);
            });
          });
          // restore opened items from history state
          openItemsFromHistoryState();
          // update lazyLoad - in case that there are some images used in Collapse buttons
          lazyLoad.update();
        }
      });

      function scrollToOpenedItem(item: HTMLElement) {
        if (props.scroll) {
          let previousItem = item.previousElementSibling;
          if (previousItem) {
            VueScrollTo.scrollTo(previousItem, {
              offset: scrollOffset
            });
          }
        }
      }

      function updateOpenedItems(item: HTMLElement) {
        if (!openedItems.includes(item.id)) {
          openedItems.push(item.id);
        } else {
          openedItems.splice(openedItems.indexOf(item.id), 1);
        }
        setHistoryState(props.id, openedItems);
      }

      function openItemsFromHistoryState() {
        const state = getHistoryState(props.id);

        if (state && Array.isArray(state) && state.length) {
          for (const item of state) {
            openedItems.push(item);
            rootEl.value?.querySelector(`[data-bs-target="#${item}"]`)?.classList.remove('collapsed');
            rootEl.value?.querySelector(`#${item}`)?.classList.add('show');
          }
        }
      }

      return {
        rootEl
      };
    }
  };
